import { render, staticRenderFns } from "./TemplateOrder.vue?vue&type=template&id=7d7d284e&"
import script from "./TemplateOrder.vue?vue&type=script&lang=ts&"
export * from "./TemplateOrder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports